import { NgModule } from '@angular/core';

import { DragAndDropDirective } from './drag-drop.directive';

@NgModule({
    declarations: [DragAndDropDirective],
    exports: [DragAndDropDirective]
})
export class DigihavenDirectiveModule {}
